let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lySio")).then(() => parcelRequire('8chQR'));